import Home from "../screens/Home";
import ReducaoDomestico from "../screens/ReducaoDomestico";
import SuspensaoDomestico from "../screens/SuspensaoDomestico";
import ReducaoGeral from "../screens/ReducaoGeral";
import SuspensaoGeral from "../screens/SuspensaoGeral";
const sandbox = "";
export const routes = [
  {
    path: `${sandbox}/beneficio/`,
    component: Home,
    name: "Home",
    menu: false,
  },
  {
    path: `${sandbox}/beneficio/SuspensaoDomestico/`,
    component: SuspensaoDomestico,
    name: "SuspensaoDomestico",
    menu: false,
  },
  {
    path: `${sandbox}/beneficio/ReducaoDomestico/`,
    component: ReducaoDomestico,
    name: "ReducaoDomestico",
    menu: false,
  },
  {
    path: `${sandbox}/beneficio/SuspensaoGeral/`,
    component: SuspensaoGeral,
    name: "SuspensaoGeral",
    menu: false,
  },
  {
    path: `${sandbox}/beneficio/ReducaoGeral/`,
    component: ReducaoGeral,
    name: "ReducaoGeral",
    menu: false,
  },
  {
    path: '*',
    component: Home,
  }
];
